/* eslint-disable max-len */
import update from 'immutability-helper';
import {
  DEFAULT_ML_METRICS,
  DEFAULT_ML_METRIC_SORT,
  DEFAULT_ML_DIMENSION,
} from '@utils/metricLens/mapping';
import * as types from './types';

const initialState = {
  appliedFilters: [],
  selectedMetrics: DEFAULT_ML_METRICS,
  selectedDimension: DEFAULT_ML_DIMENSION,
  appliedSort: DEFAULT_ML_METRIC_SORT,
  liveMode: false,
  unit: '#',
  appliedSearch: '',
};

const switchMap = {};

switchMap[types.UPDATE] = (state, action) => {
  const { persistedState } = action;
  return update(state, {
    $merge: {
      ...persistedState,
    },
  });
};

switchMap[types.INIT] = (state) =>
  update(state, {
    $set: initialState,
  });

switchMap[types.SET_SELECTED_METRICS] = (state, action) =>
  update(state, {
    selectedMetrics: { $set: action.metrics },
  });

switchMap[types.SET_SELECTED_DIMENSION] = (state, action) =>
  update(state, {
    selectedDimension: { $set: action.dimension },
    appliedSearch: { $set: '' },
  });

switchMap[types.SET_APPLIED_SORT] = (state, action) =>
  update(state, {
    appliedSort: { $set: action.sort },
  });

switchMap[types.SET_SELECTED_FILTERS] = (state, action) => {
  const { filter, index } = action;
  const { appliedFilters } = state;
  const newFilter = {
    ...appliedFilters[index],
    filter,
  };
  return update(state, {
    appliedFilters: { $splice: [[index, 1, newFilter]] },
  });
};

switchMap[types.SET_DEFAULT_FILTER_INTERVAL] = (state, action) => {
  const { filter, interval, color, index, granularity, shortcut } = action;
  const { appliedFilters } = state;
  const newFilter = {
    ...appliedFilters[index],
    filter,
    interval,
    color,
    granularity,
    shortcut,
  };
  return update(state, {
    appliedFilters: { $splice: [[index, 1, newFilter]] },
  });
};

switchMap[types.SET_SELECTED_SHORTCUT] = (state, action) => {
  const { shortcut, index } = action;
  const { appliedFilters } = state;
  const newFilter = {
    ...appliedFilters[index],
    shortcut,
  };
  return update(state, {
    appliedFilters: { $splice: [[index, 1, newFilter]] },
  });
};

switchMap[types.SET_SELECTED_INTERVAL] = (state, action) => {
  const { interval, index } = action;
  const { appliedFilters } = state;
  const newFilter = {
    ...appliedFilters[index],
    interval,
  };
  return update(state, {
    appliedFilters: { $splice: [[index, 1, newFilter]] },
  });
};

switchMap[types.SET_SELECTED_GRANULARITY] = (state, action) => {
  const { granularity, index } = action;
  const { appliedFilters } = state;
  const newFilter = {
    ...appliedFilters[index],
    granularity,
  };
  return update(state, {
    appliedFilters: { $splice: [[index, 1, newFilter]] },
  });
};

switchMap[types.SET_LIVE_MODE] = (state, action) => {
  const { mode } = action;
  return update(state, {
    liveMode: { $set: mode },
  });
};

switchMap[types.SET_UNIT_MODE] = (state, action) => {
  const { unit } = action;
  return update(state, {
    unit: { $set: unit },
  });
};

switchMap[types.REMOVE_APPLIED_FILTER] = (state, action) => {
  const { index } = action;
  return update(state, {
    appliedFilters: { $splice: [[index, 1]] },
  });
};

switchMap[types.SET_APPLIED_SEARCH] = (state, action) =>
  update(state, {
    appliedSearch: { $set: action.search },
  });

export default (state = initialState, action) =>
  switchMap[action.type] ? switchMap[action.type](state, action) : state;
